const ENVIRONMENT_MAP = {
  'dockerlocal': 'http://dockerlocal/bff',
  'homolog': 'https://workspace-homolog.vianuvem.com.br/bff',
  'qa': 'https://workspace-qa.vianuvem.com.br/bff',
  'sandbox': 'https://workspace-sandbox.vianuvem.com.br/bff',
  'production': 'https://workspace.vianuvem.com.br/bff'
}

function getBffEndpoint() {
  let endpoint;
  Object.keys(ENVIRONMENT_MAP).forEach(key => {
    if (window.location.href.includes(key)) {
      endpoint = ENVIRONMENT_MAP[key]
      return false
    }
  })
  return endpoint || ENVIRONMENT_MAP['production'];
}

//export const BFF_ENDPOINT = 'http://localhost:3333';
export const BFF_ENDPOINT = getBffEndpoint();
export const VIANUVEM_API_ENDPOINT = `${window.location.protocol}//${window.location.hostname}/AdminVianuvem`;



// WEBPACK FOOTER //
// ./src/integrations/Defaults.js